import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

export const SkeletonLoader = styled.div<{
  width: string;
  height: string;
  circle?: boolean;
}>`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  border-radius: ${(props) => (props.circle ? '50%' : '4px')};
  background-color: ${({ theme }) => theme.colorsInObjects.gray[600]};
  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme.colorsInObjects.gray[600]} 0%,
    #f0f0f0 20%,
    ${({ theme }) => theme.colorsInObjects.gray[600]} 40%,
    ${({ theme }) => theme.colorsInObjects.gray[600]} 100%
  );
  background-repeat: no-repeat;
  background-size: 1000px 100%;
  animation: ${shimmer} 1.5s infinite linear;
`;
